import React, { useState, useEffect } from 'react';
import { 
  Container,
  Typography, 
  Box,
  TextField,
  Button,
  IconButton,
  Grid,
  Paper,
  Snackbar,
  Alert
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import apiService from '../../../services/apiService';
import './BPSUserManagement.css';

const BPSUserManagement = () => {
  const [users, setUsers] = useState([{ username: '', password: '' }]);
  const [loading, setLoading] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await apiService.get('/api/configuration/bps-users');
      if (response && response.length > 0) {
        setUsers(response);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      setError('Error al cargar los usuarios');
    } finally {
      setLoading(false);
    }
  };

  const handleAddRow = () => {
    setUsers([...users, { username: '', password: '' }]);
  };

  const handleDeleteRow = (index) => {
    setUsers(users.filter((_, i) => i !== index));
  };

  const handleUserChange = (index, field, value) => {
    const newUsers = [...users];
    newUsers[index][field] = value;
    setUsers(newUsers);
  };

  const handleSave = async () => {
    try {
      await apiService.post('/api/configuration/bps-users', users);
      setShowSuccess(true);
    } catch (error) {
      console.error('Error saving users:', error);
      setError('Error al guardar los usuarios');
    }
  };

  const handleCloseSnackbar = () => {
    setShowSuccess(false);
    setError('');
  };

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography>Cargando usuarios...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom align="center" sx={{ mb: 4 }}>
          Gestión de Usuarios BPS
        </Typography>
        
        <Grid container spacing={2}>
          {users.map((user, index) => (
            <React.Fragment key={index}>
              <Grid item xs={5}>
                <TextField
                  label="Nombre de Usuario"
                  variant="outlined"
                  value={user.username}
                  onChange={(e) => handleUserChange(index, 'username', e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  label="Contraseña"
                  variant="outlined"
                  type="password"
                  value={user.password}
                  onChange={(e) => handleUserChange(index, 'password', e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={2}>
                <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteRow(index)}>
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>

        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between' }}>
          <Button variant="contained" color="primary" onClick={handleAddRow}>
            +
          </Button>
          <Button variant="contained" color="secondary" onClick={handleSave}>
            Guardar
          </Button>
        </Box>

        <Snackbar 
          open={showSuccess} 
          autoHideDuration={3000} 
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
            Usuarios guardados exitosamente
          </Alert>
        </Snackbar>

        <Snackbar
          open={!!error}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Snackbar>
      </Paper>
    </Container>
  );
};

export default BPSUserManagement;